// libraries
import React from "react";

// components
import { HomeContent } from "src/content";

const Home = () => {
  return (
    <div>
      <HomeContent />
    </div>
  );
};

export default Home;
